import React, { useState } from 'react';
import { Button, Col, Collapse, Row } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons';

type Props = {
  children: React.ReactNode,
  defaultOpen?: boolean,
  title: string
}

export default function ContactSection({ children, defaultOpen, title }: Props) {
  const [open, setOpen] = useState(!!defaultOpen);

  return (
    <div className="bg-light p-3">
      <Row className="align-items-center">
        <Col><strong>{title}</strong></Col>
        <Col xs="auto">
          <Button className="btn-icon" variant="secondary-text" onClick={() => setOpen(!open)}>
            <FontAwesomeIcon icon={faAngleRight} rotation={open ? 90 : undefined} />
          </Button>
        </Col>
      </Row>
      <Collapse in={open}>
        <div>
          {children}
        </div>
      </Collapse>
    </div>
  );
}
